import { useQuery } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";
import { WithdrawalWithUser } from "libs/dto/src/withdrawal";

const withdrawals = async (userId: string, page: number, status?: string) => {
  const response = await axios.get<{ page: number; data: WithdrawalWithUser[] }>(`/withdrawals`, {
    params: {
      userId: { equals: userId },
      status: { equals: status },
      page: page,
    },
  });
  return response.data;
};

export const useMyWithdrawals = (userId: string, page: number, status?: string) => {
  const {
    data: withdrawal,
    isPending: loading,
    error,
  } = useQuery({
    queryKey: ["my-withdrawals", userId, page],
    queryFn: () => withdrawals(userId, page, status),
  });

  return { withdrawal, loading, error };
};
